// Module
var code = "<div layout-gt-xs=\"row\">\n    <equipment-grid-switch module=\"protectiveEquipment\" identifier=\"{{$ctrl.identifier}}\"></equipment-grid-switch>\n</div>\n";
// Exports
module.exports = code;